import './scss/pages/archive-staff.scss';
import { searchFilters } from './js/components/search-filters.js';

window.addEventListener( 'DOMContentLoaded', () => {

	searchFilters();

} );
